// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"227":"531c9fa7de179130","235":"a92be3914daaac33","252":"74ca65a4d0dca47e","437":"fccbb29a54359b87","798":"4da98cf8301e16a3","844":"e7285a2703ca2e5c","986":"51eb7064a51395a9"}[chunkId] + ".js";
};